import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _6cce7d3c = () => interopDefault(import('../pages/about.vue' /* webpackChunkName: "pages/about" */))
const _ac417c76 = () => interopDefault(import('../pages/bindAccount.vue' /* webpackChunkName: "pages/bindAccount" */))
const _4767d42f = () => interopDefault(import('../pages/consent.vue' /* webpackChunkName: "pages/consent" */))
const _2e938fa2 = () => interopDefault(import('../pages/coupons.vue' /* webpackChunkName: "pages/coupons" */))
const _9325c8d0 = () => interopDefault(import('../pages/game-ids.vue' /* webpackChunkName: "pages/game-ids" */))
const _2d5ec7b2 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _3d8a5b93 = () => interopDefault(import('../pages/me.vue' /* webpackChunkName: "pages/me" */))
const _3e255e1e = () => interopDefault(import('../pages/mp.vue' /* webpackChunkName: "pages/mp" */))
const _418a9ce6 = () => interopDefault(import('../pages/order/index.vue' /* webpackChunkName: "pages/order/index" */))
const _0fa0943d = () => interopDefault(import('../pages/pay.vue' /* webpackChunkName: "pages/pay" */))
const _29e1e728 = () => interopDefault(import('../pages/procedure.vue' /* webpackChunkName: "pages/procedure" */))
const _819bd136 = () => interopDefault(import('../pages/setting.vue' /* webpackChunkName: "pages/setting" */))
const _0e36ba87 = () => interopDefault(import('../pages/takings/index.vue' /* webpackChunkName: "pages/takings/index" */))
const _4fa6905c = () => interopDefault(import('../pages/wx.vue' /* webpackChunkName: "pages/wx" */))
const _0739c74e = () => interopDefault(import('../pages/auth/binding.vue' /* webpackChunkName: "pages/auth/binding" */))
const _49001eff = () => interopDefault(import('../pages/auth/forgot.vue' /* webpackChunkName: "pages/auth/forgot" */))
const _1380a5c6 = () => interopDefault(import('../pages/auth/help.vue' /* webpackChunkName: "pages/auth/help" */))
const _20878a3d = () => interopDefault(import('../pages/auth/login.vue' /* webpackChunkName: "pages/auth/login" */))
const _7a504d12 = () => interopDefault(import('../pages/auth/password.vue' /* webpackChunkName: "pages/auth/password" */))
const _3b41097f = () => interopDefault(import('../pages/auth/register.vue' /* webpackChunkName: "pages/auth/register" */))
const _8d4fe3f4 = () => interopDefault(import('../pages/oauth/authorize.vue' /* webpackChunkName: "pages/oauth/authorize" */))
const _03fde3bc = () => interopDefault(import('../pages/order/cart.vue' /* webpackChunkName: "pages/order/cart" */))
const _67ee90e2 = () => interopDefault(import('../pages/order/checkout.vue' /* webpackChunkName: "pages/order/checkout" */))
const _0cbf04d4 = () => interopDefault(import('../pages/order/confirm.vue' /* webpackChunkName: "pages/order/confirm" */))
const _41a8967d = () => interopDefault(import('../pages/teams/policies/privacy.vue' /* webpackChunkName: "pages/teams/policies/privacy" */))
const _150bd213 = () => interopDefault(import('../pages/teams/policies/refund.vue' /* webpackChunkName: "pages/teams/policies/refund" */))
const _751bdb2a = () => interopDefault(import('../pages/teams/policies/service.vue' /* webpackChunkName: "pages/teams/policies/service" */))
const _e1676128 = () => interopDefault(import('../pages/order/product/_product.vue' /* webpackChunkName: "pages/order/product/_product" */))
const _2d6330e4 = () => interopDefault(import('../pages/orders/_order.vue' /* webpackChunkName: "pages/orders/_order" */))
const _f546a25e = () => interopDefault(import('../pages/s/_token.vue' /* webpackChunkName: "pages/s/_token" */))
const _09209aa2 = () => interopDefault(import('../pages/takings/_id.vue' /* webpackChunkName: "pages/takings/_id" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/about",
    component: _6cce7d3c,
    name: "about___mo"
  }, {
    path: "/bindAccount",
    component: _ac417c76,
    name: "bindAccount___mo"
  }, {
    path: "/consent",
    component: _4767d42f,
    name: "consent___mo"
  }, {
    path: "/coupons",
    component: _2e938fa2,
    name: "coupons___mo"
  }, {
    path: "/game-ids",
    component: _9325c8d0,
    name: "game-ids___mo"
  }, {
    path: "/hk",
    component: _2d5ec7b2,
    name: "index___hk"
  }, {
    path: "/me",
    component: _3d8a5b93,
    name: "me___mo"
  }, {
    path: "/mp",
    component: _3e255e1e,
    name: "mp___mo"
  }, {
    path: "/order",
    component: _418a9ce6,
    name: "order___mo"
  }, {
    path: "/pay",
    component: _0fa0943d,
    name: "pay___mo"
  }, {
    path: "/procedure",
    component: _29e1e728,
    name: "procedure___mo"
  }, {
    path: "/setting",
    component: _819bd136,
    name: "setting___mo"
  }, {
    path: "/takings",
    component: _0e36ba87,
    name: "takings___mo"
  }, {
    path: "/wx",
    component: _4fa6905c,
    name: "wx___mo"
  }, {
    path: "/auth/binding",
    component: _0739c74e,
    name: "auth-binding___mo"
  }, {
    path: "/auth/forgot",
    component: _49001eff,
    name: "auth-forgot___mo"
  }, {
    path: "/auth/help",
    component: _1380a5c6,
    name: "auth-help___mo"
  }, {
    path: "/auth/login",
    component: _20878a3d,
    name: "auth-login___mo"
  }, {
    path: "/auth/password",
    component: _7a504d12,
    name: "auth-password___mo"
  }, {
    path: "/auth/register",
    component: _3b41097f,
    name: "auth-register___mo"
  }, {
    path: "/hk/about",
    component: _6cce7d3c,
    name: "about___hk"
  }, {
    path: "/hk/bindAccount",
    component: _ac417c76,
    name: "bindAccount___hk"
  }, {
    path: "/hk/consent",
    component: _4767d42f,
    name: "consent___hk"
  }, {
    path: "/hk/coupons",
    component: _2e938fa2,
    name: "coupons___hk"
  }, {
    path: "/hk/game-ids",
    component: _9325c8d0,
    name: "game-ids___hk"
  }, {
    path: "/hk/me",
    component: _3d8a5b93,
    name: "me___hk"
  }, {
    path: "/hk/mp",
    component: _3e255e1e,
    name: "mp___hk"
  }, {
    path: "/hk/order",
    component: _418a9ce6,
    name: "order___hk"
  }, {
    path: "/hk/pay",
    component: _0fa0943d,
    name: "pay___hk"
  }, {
    path: "/hk/procedure",
    component: _29e1e728,
    name: "procedure___hk"
  }, {
    path: "/hk/setting",
    component: _819bd136,
    name: "setting___hk"
  }, {
    path: "/hk/takings",
    component: _0e36ba87,
    name: "takings___hk"
  }, {
    path: "/hk/wx",
    component: _4fa6905c,
    name: "wx___hk"
  }, {
    path: "/oauth/authorize",
    component: _8d4fe3f4,
    name: "oauth-authorize___mo"
  }, {
    path: "/order/cart",
    component: _03fde3bc,
    name: "order-cart___mo"
  }, {
    path: "/order/checkout",
    component: _67ee90e2,
    name: "order-checkout___mo"
  }, {
    path: "/order/confirm",
    component: _0cbf04d4,
    name: "order-confirm___mo"
  }, {
    path: "/hk/auth/binding",
    component: _0739c74e,
    name: "auth-binding___hk"
  }, {
    path: "/hk/auth/forgot",
    component: _49001eff,
    name: "auth-forgot___hk"
  }, {
    path: "/hk/auth/help",
    component: _1380a5c6,
    name: "auth-help___hk"
  }, {
    path: "/hk/auth/login",
    component: _20878a3d,
    name: "auth-login___hk"
  }, {
    path: "/hk/auth/password",
    component: _7a504d12,
    name: "auth-password___hk"
  }, {
    path: "/hk/auth/register",
    component: _3b41097f,
    name: "auth-register___hk"
  }, {
    path: "/hk/oauth/authorize",
    component: _8d4fe3f4,
    name: "oauth-authorize___hk"
  }, {
    path: "/hk/order/cart",
    component: _03fde3bc,
    name: "order-cart___hk"
  }, {
    path: "/hk/order/checkout",
    component: _67ee90e2,
    name: "order-checkout___hk"
  }, {
    path: "/hk/order/confirm",
    component: _0cbf04d4,
    name: "order-confirm___hk"
  }, {
    path: "/teams/policies/privacy",
    component: _41a8967d,
    name: "teams-policies-privacy___mo"
  }, {
    path: "/teams/policies/refund",
    component: _150bd213,
    name: "teams-policies-refund___mo"
  }, {
    path: "/teams/policies/service",
    component: _751bdb2a,
    name: "teams-policies-service___mo"
  }, {
    path: "/hk/teams/policies/privacy",
    component: _41a8967d,
    name: "teams-policies-privacy___hk"
  }, {
    path: "/hk/teams/policies/refund",
    component: _150bd213,
    name: "teams-policies-refund___hk"
  }, {
    path: "/hk/teams/policies/service",
    component: _751bdb2a,
    name: "teams-policies-service___hk"
  }, {
    path: "/",
    component: _2d5ec7b2,
    name: "index___mo"
  }, {
    path: "/hk/order/product/:product?",
    component: _e1676128,
    name: "order-product-product___hk"
  }, {
    path: "/hk/orders/:order?",
    component: _2d6330e4,
    name: "orders-order___hk"
  }, {
    path: "/hk/s/:token?",
    component: _f546a25e,
    name: "s-token___hk"
  }, {
    path: "/hk/takings/:id",
    component: _09209aa2,
    name: "takings-id___hk"
  }, {
    path: "/order/product/:product?",
    component: _e1676128,
    name: "order-product-product___mo"
  }, {
    path: "/orders/:order?",
    component: _2d6330e4,
    name: "orders-order___mo"
  }, {
    path: "/s/:token?",
    component: _f546a25e,
    name: "s-token___mo"
  }, {
    path: "/takings/:id",
    component: _09209aa2,
    name: "takings-id___mo"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
